import React, { useEffect, useState } from 'react';
import { Row, Col, BackTop, Tooltip, Typography, Space } from 'antd';
import {UpCircleOutlined} from '@ant-design/icons'

export default function MyFooter() {
    const [email, setEmail] = useState();

    useEffect(() => {
        fetch('https://d3dw8uwyhfr6bk.cloudfront.net/default_info.json')
            .then(response => response.json())
            .then(data => {
                console.log(data.email);
                setEmail(data.email);
            })
            .catch(error => {
                console.error('Error fetching email:', error);
            });
    }, [])

    return (
        <>
            <div style={{height:"30px"}} />
            <Typography.Paragraph style={{ fontSize: "12px" }}><b>Biodesign Center, Key Laboratory of Engineering Biology for Low-carbon Manufacturing, Tianjin Institute of Industrial Biotechnology, Chinese Academy of Sciences.</b></Typography.Paragraph>
            <Typography.Paragraph style={{ fontSize: "12px" }}><Space><b>National Technology Innovation Center of Synthetic Biology.</b> <b>Contact Us: <a disabled={email ? false : true} href={`mailto:${email}`}><i>{email ? email : "loading"}</i></a></b></Space></Typography.Paragraph>
            <Typography.Paragraph style={{ fontSize: "12px" }}><b><i>Our website is free for all users, including commercial users.</i></b></Typography.Paragraph>
            <BackTop className="BackTopIcon">
                <Tooltip title="Back Top">
                    {/* <Icon name="chevron circle up" size="huge" color="grey" /> */}
                    <UpCircleOutlined style={{fontSize:"50px"}} />
                </Tooltip>
            </BackTop>
        </>
    )
}
